module.exports = __webpack_public_path__ + "img/divider-3.5fc4e4dd.svg";